module.exports = __webpack_public_path__ + "static/media/20180203_100307.ac4e481f.jpg";